import { TimeStandard, TimezoneOffset, TimezoneOffsetText } from './constants'
import type { LocaleConfig } from './type'

enum TimezonePH {
  MANILA = 'Asia/Manila',
}

const localeConfig: LocaleConfig = {
  helpCenterUrl: 'https://help.shopee.ph/portal/4/ph/s',
  /**
   * timezone
   */
  defaultTimezone: TimezonePH.MANILA,
  getTimezone: (timezone?: string) => {
    const lowerTimezone = timezone?.toLowerCase()
    const config = {
      [TimezonePH.MANILA.toLowerCase()]: {
        timezoneStandardText: TimeStandard.WITA,
        timezoneOffset: TimezoneOffset.UTC8,
        timezoneOffsetText: TimezoneOffsetText[TimezoneOffset.UTC8],
        timezoneName: TimezonePH.MANILA,
      },
    }
    return config[lowerTimezone as TimezonePH] || config[TimezonePH.MANILA.toLowerCase()]
  },

  currency: {
    CODE: 'PHP',
    LOCALES: 'en-PH',
    SYMBOL: '₱',
    MIN_FRACTION_DIGITS: 2,
    MAX_FRACTION_DIGITS: 2,
  },

  wallet: {
    availableBalanceReachAmount: 'no limit',
  },

  price: {
    regExp: /^(\d+)(\.\d{0,2})?$/,
    precision: 2,
  },

  menu: {
    dish: {
      minPrice: 0.01,
      maxPrice: 10000000,
    },
  },

  order: {
    history: {
      maxDateRange: 90,
      maxDateRangeSelecting: Number.MAX_SAFE_INTEGER,
      defaultDateRangeSelecting: 7,
      maxStoreIds: 200,
    },
  },
}

export default localeConfig
